import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { StepTile } from '@tran-monorepo/interfaces';
import { CustomTextLinkComponent } from '../../custom-links';

@Component({
    selector: 'tran-step-tile',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, CustomTextLinkComponent],
    templateUrl: './step-tile.component.html'
})
export class StepTileComponent {
    public readonly tile = input.required<StepTile>();
    public readonly stepPrefix = input<string>('components.step-section.step');
    public readonly isLast = input<boolean>(false);
}
